import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Label } from "reactstrap";
import CommonFileUpload from "../CommonFileUpload";
import LabelText from "./LableText";

const DropItem = (props) => {
  const { label = true, register, control, errors, ...res } = props;
  const name = register.name;
  const labelText = LabelText(name);

  return (
    <FormGroup>
      {label && <Label style={{ textTransform: "capitalize" }}>{labelText}</Label>}
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <>
            <CommonFileUpload />
            <ErrorMessage errors={errors} name={name} render={({ message }) => <span style={{ color: "red" }}>{`${labelText} ${message}`}</span>} />
          </>
        )}
      />
    </FormGroup>
  );
};

export default DropItem;
